<section class="rv">
  <header class="rv__head">
    <span class="rv__tick" [class.is-pending]="!complete" aria-hidden="true">
      @if (complete) {
        <span class="bk-sym">check</span>
      }
    </span>
    <h3 class="bk-heading rv__title">
      {{ title }}
      @if (!complete) {
        <span class="bk-sr-only">, not finished</span>
      }
    </h3>
    <button
      type="button"
      class="bk-icon-btn rv__edit"
      [attr.aria-label]="'Edit ' + (title || 'section').toLowerCase()"
      [matTooltip]="'Edit ' + (title || 'section').toLowerCase()"
      (click)="onEdit.emit()"
    >
      <span class="bk-sym" aria-hidden="true">edit</span>
    </button>
  </header>

  <div class="rv__body">
    <ng-content></ng-content>
  </div>
</section>
